<div class="page-container gap-24">
  <div class="page-navigation">
    <h2 class="page-title">Meine Mitgliederbereiche</h2>

    <!-- Redeem Button -->
    <button
      class="inwi-text-button-medium-secondary"
      (click)="showRedeemCodeDialog()">
      <div class="button-content">
        <div class="button-icon">
          <i class="fa-regular fa-key"></i>
        </div>
        <div class="button-text">Code einlösen</div>
      </div>
    </button>
  </div>

  @if (loading) {
    <div class="loading">Lade Bereiche...</div>
  } @else if (areas.length === 0) {
    <div class="no-areas">Du bist aktuell in keinem Mitgliederbereich.</div>
  } @else {
    <div class="areas">
      @for (a of areas; track a.id) {
        <div class="member-area member-area-hover" (click)="goToArea(a)">
          @if (a.image) {
            <img
              class="image"
              [src]="getAreaImage(a)"
              alt="Bild des Mitgliederbereichs" />
          } @else {
            <div class="image-placeholder">
              <i class="fa-regular fa-image"></i>
            </div>
          }
          <div class="details">
            <div class="title">{{ a.name }}</div>
            <div class="role-row">
              <div class="role">
                <span class="role-chip">
                  @switch (a.role) {
                    @case ('OWNER') {
                      Eigentümer
                    }
                    @case ('ADMIN') {
                      Admin
                    }
                    @default {
                      Mitglied
                    }
                  }
                </span>
              </div>
              @if (!a.isPublic) {
                <span class="member-count">
                  {{
                    a.memberCount === 1
                      ? '1 Mitglied'
                      : a.memberCount + ' Mitglieder'
                  }}
                </span>
              }
            </div>
            @if (a.description) {
              <div class="area-desc">
                {{ a.description }}
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
